import styled from 'styled-components'
import { rem } from 'polished'

export const TasteOfGoldPromoCard = styled.div`
  width: 100%;
  border-radius: ${props => props.theme.borderRadius.L};
  border: 1px solid ${props => props.theme.palette.neutral.surface.lightForeground};
  background: ${props => props.theme.palette.neutral.surface.normalBackground};
  padding: ${rem(16)};
`

export const TasteOfGoldGoldLabel = styled.span`
  display: inline-flex;
  height: ${rem(28)};
  padding: ${rem(2)} ${rem(8)};
  align-items: center;
  gap: ${rem(4)};
  border-radius: ${rem(20)};
  background: ${props => props.theme.palette.product.loyalty.gold.gradientPrimaryBackground};
  color: ${props => props.theme.palette.product.loyalty.gold.normalContrast};
  font-family: ${props => props.theme.font.primary.family};
  font-size: ${rem(12)};
  font-weight: ${props => props.theme.font.primary.weight.bold};
  line-height: ${rem(16)};
`

export const TasteOfGoldIconCircle = styled.div`
  display: flex;
  width: ${rem(48)};
  height: ${rem(48)};
  padding-block: ${rem(4)} ${rem(5)};
  padding-inline: ${rem(4)} ${rem(5)};
  justify-content: center;
  align-items: center;
  flex-shrink: 0;

  > span {
    display: flex;
    width: ${rem(37)};
    height: ${rem(37)};
    flex-shrink: 0;
    justify-content: center;
    align-items: center;
    border-radius: ${rem(93)};
    border: ${rem(1)} solid ${props => props.theme.palette.product.loyalty.gold.normalForeground};
    background: linear-gradient(
      45deg,
      ${props => props.theme.palette.product.loyalty.gold.normalBackground} 0.73%,
      ${props => props.theme.palette.product.loyalty.gold.lightBackground} 45.77%,
      ${props => props.theme.palette.product.loyalty.gold.normalBackground} 74.49%
    );
    color: ${props => props.theme.palette.product.loyalty.gold.normalContrast};
  }
`
